import React, { useEffect, useState } from "react";
import { Menu, Icon, Dropdown, Loader } from "semantic-ui-react";
import {toast, Toaster } from 'react-hot-toast';
// import { useApiKey, useAuth } from "../../../hooks";
// import { ModalBasic } from "../../Common";
// import { useUser } from "../../../hooks";
import { DoubleLeftOutlined, DoubleRightOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import moment from "moment";

import "./TopMenu.scss";
import DataTable from "react-data-table-component";

export function TopMenu(props) {
  const { collapsedMenuAnt, setCollapsedMenuAnt } = props;
  // const { auth, ultimohotel, setUltimoHotel,  setApiSeleccionada, logout,} = useAuth();
  // const { updateHotelUser } = useUser();
  // const { getOpcionesPerHotel } = useOpciones();
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState(null);
  const [contentModal, setContentModal] = useState(null);
  const [hotelSeleccionado, setHotelSeleccionado] = useState([]);
  const openCloseModal = () => setShowModal((prev) => !prev);
  // const { loading, apiKeys, getApiKeys, updateApiKeyUser } = useApiKey();

  // const role = auth.me?.role;

  const renderName = () => {
    var usuarioRender = "";

    /*if (auth.me?.name) {
      usuarioRender = `${auth.me.name}`;
    } else {
      usuarioRender = auth.me?.email;
    }*/

    return usuarioRender;
  };


  // const renderOpciones = () => {
  //   //console.log(opcionesHotel?.ultcierre);
  //   var opcionesRender = "";
  //   if (opcionesHotel?.nombre?.length > 0) {
  //     opcionesRender = moment(opcionesHotel?.ultcierre).format("DD/MM/YYYY");
  //   } else {
  //     opcionesRender = "Seleccionar hotel";
  //   }

  //   return opcionesRender;
  // };
  useEffect(() => {

  }, []); // [] -> no tiene parametros por lo que se ejecuta una vez

  useEffect(() => {
    try {
      const fetchData = async () => {
        
      };
      fetchData().catch((error) => {
        toast.error("No se ha podido seleccionar el nuevo hotel. " + error);
      });
    } catch (error) {
      toast.error(
        "No se ha podido seleccionar el nuevo hotel, inténtelo mas tarde. "
      );
    }
  }, [hotelSeleccionado]);


  function renderRow(row, data) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          alignContent: "center",
          cursor: "pointer",
        }}
        data-tag="allowRowEvents"

      >
        {data}
      </div>
    );
  }

  return (
    <>
      <Menu fixed="top" className="top-menu-admin">
        <Menu.Item
          style={{
            width: collapsedMenuAnt ? "80px" : "250px",
            left: collapsedMenuAnt ? "8px" : "",
          }}
          className="top-menu-admin__logo"
        >
          {collapsedMenuAnt ? "" : "pNotas"}
          {/* <Button
            className="top-menu-admin__logo__btnMenu"
            color="blue"
            onClick={() => setCollapsedMenuAnt(!collapsedMenuAnt)}
          >
            {collapsedMenuAnt ? <RightOutlined /> : <LeftOutlined />}
          </Button> */}

          <Button
            className="top-menu-admin__logo__btnMenu"
            type="primary"
            shape="circle"
            icon={
              collapsedMenuAnt ? (
                <DoubleRightOutlined />
              ) : (
                <DoubleLeftOutlined />
              )
            }
            onClick={() => setCollapsedMenuAnt(!collapsedMenuAnt)}
          />
        </Menu.Item>

        {/* <Menu.Item>
          <Button
            color="blue"
            onClick={() => setCollapsedMenuAnt(!collapsedMenuAnt)}
          >
            {collapsedMenuAnt ? <RightOutlined /> : <LeftOutlined />}
          </Button>
        </Menu.Item> */}
        <Menu.Menu position="right">
          <Menu.Item>
            <div style={{ color: "white" }}>Hola,&nbsp;&nbsp;</div>
            <Dropdown style={{ color: "white" }} text={renderName()}>
              <Dropdown.Menu>
                <Dropdown.Item>
                  <Icon name="asterisk" />
                  Aqui iran mas opciones
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Menu.Item>

          <Menu.Item style={{ color: "white" }} /*onClick={logout}*/>
            <Icon name="sign-out" />
          </Menu.Item>
        </Menu.Menu>
      </Menu>

    </>
  );
}
